export default __webpack_public_path__ + "static/icomoon-5376755bf87588d28d277e297f98f07c.eot";